import style from './NotValidFieldText.module.scss';

export interface FieldTitleParams {
    title: string;
}

interface Props extends FieldTitleParams {}

export function NotValidFieldText({ title }: Props) {
    return <div className={style.root}>{title}</div>;
}
